export interface Carrier {
  ID: number;
  name: string;
  shortName: string;
  favorite: boolean;
  rating: string;
}

export interface CarrierFinancials {
  issuingCompanyName: string;
  financialSizeCategory: string;
  businessStatusReason: string;
  rating: string;
  indexPos: number;
}

export interface CarrierPremiumByAgency {
  agencyName: string;
  sourceAgencyKey: string;
  policyYear: number;
  policyMonth: number;
  insurerGroupID: number;
  policyPremium: number;
}

export enum WholesalerFilter {
  ALL = 'ALL',
  RETAIL = 'RETAIL',
  WHOLESALE = 'WHOLESALE',
}

export interface CarrierPremiumByWholesaler {
  wholesalerGroup: string | null | undefined;
  coverageType: string | null | undefined,
  policyPremium: number;
}

export interface CarrierGroup {
  insurerGroup: string;
  carriers: CarrierRating[];
}

export interface CarrierRating {
  insurerGroup: string;
  issuingCompanyName: string;
  financialStrengthRating: string | null | undefined;
  sizeCategory: string | null | undefined;
  categoryRaw: string | null | undefined;
  outlook: string | null | undefined;
  ratingEffectiveDate?: string;
  previousRating?: string;
}

export interface IssuingCompany {
  issuingCompanyId: number;
  issuingCompanyName: string;
  issuingCompanyCode: string;
  insurerGroupId: number;
  insurerGroupName: string;
  currentRating?: string;
}

export interface CarrierShareOfWallet {
  dataType: 'TTM' | 'YTD' | 'TOTAL';
  carrierName: string;
  coverageType: string;
  totalPremiumYTD: number;
  totalPremiumPreviousYTD: number;
  totalPremiumTTM: number;
  totalPremiumPreviousTTM: number;
  carrierPremiumYTD: number;
  carrierPremiumPreviousYTD: number;
  carrierPremiumTTM: number;
  carrierPremiumPreviousTTM: number;
  totalPoliciesYTD: number;
  totalPoliciesPreviousYTD: number;
  totalPoliciesTTM: number;
  totalPoliciesPreviousTTM: number;
  carrierPoliciesYTD: number;
  carrierPoliciesPreviousYTD: number;
  carrierPoliciesTTM: number;
  carrierPoliciesPreviousTTM: number;
  totalClientsYTD: number;
  totalClientsPreviousYTD: number;
  totalClientsTTM: number;
  totalClientsPreviousTTM: number;
  carrierClientsYTD: number;
  carrierClientsPreviousYTD: number;
  carrierClientsTTM: number;
  carrierClientsPreviousTTM: number;
}

export interface CarrierPoliciesByIdParams {
    includeExpired: boolean;
    showExternal: boolean;
    offset: number;
    limit: number;
    sortField: string;
    sortDirection: string;
    searchQuery?: string;
    searchField?: string;
    servicingRolesSearch?: string;
    industries?: string[];
    includeIndustryChildren: boolean;
    hideUnpublishedRoles: boolean;
}

export interface CarrierTopClients {
  accountName: string;
  accountID: number;
  domainName?: string;
  coverageTypes: string | string[];
  industries: string;
  totalPremium: number;
}
